export default __webpack_public_path__ + "static/media/pw.52d42684.png";